import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import ban from '../Assets/sl1.png'
import ban2 from '../Assets/sl2.png'
import ban3 from '../Assets/sl3.png'


// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';


function Slider() {
  return (
    <>
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      <SwiperSlide className='slider1'>
      <img src={ban}/>

      </SwiperSlide>
      <SwiperSlide className='slider2'>
      <img src={ban2}/>

      </SwiperSlide>
      <SwiperSlide className='slider3'>
      <img src={ban3}/>
        
      </SwiperSlide>

      {/* <SwiperSlide>Slide 2</SwiperSlide>
      <SwiperSlide>Slide 3</SwiperSlide>
      <SwiperSlide>Slide 4</SwiperSlide>
      <SwiperSlide>Slide 5</SwiperSlide>
      <SwiperSlide>Slide 6</SwiperSlide>
      <SwiperSlide>Slide 7</SwiperSlide>
      <SwiperSlide>Slide 8</SwiperSlide>
      <SwiperSlide>Slide 9</SwiperSlide> */}
    </Swiper>
  </>
  )
}

export default Slider